export default {
    find_offers_by: 'Найти услуги по',
}
